import Sales from 'dash/js/services/Sales'
import SalesHelper from 'dash/js/helpers/SalesHelper'
import FilterStruct from 'dash/js/schemas/filters.struct'

/**
 * @param commit
 * @param rootState
 * @param rootGetters
 * @param dispatch
 * @param data
 */
export const retrieveSales = ({ commit, rootGetters }, data) => {
  let params = data ? data : FilterStruct

  let filters = Object.assign(params, { by: 'updated-between',  type: 'tickets' })

  Sales.retrieve(filters, response => {
    SalesHelper.verifySales(
      response.data,
      { clients: rootGetters['clients/clients'] },
      response => commit('retrieveSales', response))
  })
}
